import { type NavigationActionsType, NAVIGATION_INIT, NAVIGATION_SET_STEP } from "../actions/NavigationActions";
import { type NavigationType, NavStep } from "../../../shared-logic/utils/Navigation";

export type NavigationStateType = NavigationType;
// In practice path and model should always be filled in.
export const initialState: NavigationStateType = {
    path: "",
    step: NavStep.Model,
    model: "",
};

const navigation = (state: NavigationStateType = initialState, action: NavigationActionsType): NavigationStateType => {
    switch (action.type) {
        case NAVIGATION_INIT:
            return { ...action.navigation };

        case NAVIGATION_SET_STEP:
            return { ...state, step: action.step };

        default:
            return state;
    }
};

export default navigation;
